/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_Outcome_ErrorInputs */

const cs_lustrace_outcome_error = /** @type {(inputs: Lustrace_Outcome_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba`)
};

const en_lustrace_outcome_error = /** @type {(inputs: Lustrace_Outcome_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Lustrace_Outcome_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_outcome_error = /** @type {((inputs?: Lustrace_Outcome_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_Outcome_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_outcome_error(inputs)
	return cs_lustrace_outcome_error(inputs)
});